import { useTranslation } from 'react-i18next'
import { ProjectWorkspace } from './components/ProjectWorkspace'
import { TeamPanel } from './components/TeamPanel'
import { WorkPanel } from './components/WorkPanel'

export function ProjectBoardsPage() {
  const { t } = useTranslation()
  return (
    <ProjectWorkspace title={t('projects.boards.title')} description={t('projects.boards.subtitle')} createLabel={t('projects.boards.create')}>
      {(project) => (
        <div className="grid grid-cols-1 divide-y lg:grid-cols-[minmax(0,5fr)_minmax(0,8fr)] lg:divide-x lg:divide-y-0">
          <TeamPanel project={project} />
          <WorkPanel project={project} />
        </div>
      )}
    </ProjectWorkspace>
  )
}
